import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-menu\"><path fill=\"currentColor\" d=\"M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol